export default __webpack_public_path__ + "static/media/999.ec497436.png";